import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { UnitConversion, UnitConversionCreate, UnitConversionFilter } from '../data/unitConversion';

export function createUnitConversionService(client: AxiosInstance) {
  return createCrudService<UnitConversion, UnitConversionCreate, UnitConversionFilter>(
    client,
    '/master-data/UnitConversion',
    'id',
  );
}

export type UnitConversionService = CrudService<UnitConversion, UnitConversionCreate, UnitConversionFilter>;
